import { SVGProps } from 'react';

export const Outreach = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44959 0.658212L5.44959 4.8327L4.18778 3.57089L3.40967 4.349L5.99988 6.93921L8.59009 4.349L7.81198 3.57089L6.55017 4.8327L6.55017 0.658212H5.44959Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11.3417C4.53018 11.3417 3.1484 10.7688 2.10946 9.72933C-0.0361189 7.58375 -0.0366691 4.09272 2.10891 1.94714L2.88702 2.72525C1.17066 4.4416 1.17121 7.23487 2.88757 8.95122C3.7185 9.78271 4.82403 10.2411 6 10.2411C7.17597 10.2411 8.2815 9.78271 9.11243 8.95122C10.8288 7.23487 10.8293 4.4416 9.11298 2.72525L9.89109 1.94714C12.0367 4.09272 12.0361 7.58375 9.89054 9.72933C8.8516 10.7688 7.46982 11.3417 6 11.3417Z"
      fill="currentColor"
    />
  </svg>
);
